












































































































import { Vue, Component, Prop } from 'vue-property-decorator'

import DesktopsStoreModule from '../store/DesktopsStoreModule'

import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import OrganizationNavigator from '@revas/kadra-library/src/revas/vue/vue-router/OrganizationNavigator'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import { App, Package, SystemInfo } from '@/models'

import AppAppCard from '@/components/homepage/AppAppCard.vue'
import AppStorePackageCard from '@/components/shop/AppStorePackageCard.vue'
import AppStoreAppDetailsOverlay from '@/components/shop/AppStoreAppDetailsOverlay.vue'

export interface AppStoreSection {
  key: string;
  pkgs: string[];
}

@Component({
  components: {
    AppAppCard,
    AppStorePackageCard,
    AppStoreAppDetailsOverlay
  }
})
export default class VShopViewer extends Vue {
  @Prop() readonly desktopsStoreModule!: DesktopsStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() organizationId!: string
  @Prop() navigator!: OrganizationNavigator
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly routeName!: string
  @Prop() systemInfo!: SystemInfo

  created () {
    this.desktopsStoreModule.asyncListApps()
    this.desktopsStoreModule.asyncListPackages()
  }

  get apps (): App[] {
    const a = this.desktopsStoreModule.apps
    if (a === null) {
      return []
    } else {
      return a
    }
  }

  get pkgs (): Package[] {
    const p = this.desktopsStoreModule.packages
    if (p === null) {
      return []
    } else {
      return p
    }
  }

  storeSections: AppStoreSection[] = [
    {
      key: 'project_management',
      pkgs: [
        'package/projects.v1',
        'package/budgets.v1',
        'package/calendars.v1',
        'package/tasks.v1',
        'package/invoices.v1'
      ]
    },
    {
      key: 'human_resources',
      pkgs: [
        'package/humans.v1',
        'package/timesheets.v1',
        'package/timecards.v1',
        'package/reimbursements.v1'
      ]
    },
    {
      key: 'web_online',
      pkgs: [
        'package/websites.v1',
        'package/contents.v2',
        'package/products.v1',
        'package/contents.v1',
        'package/payments.v1'
      ]
    },
    {
      key: 'stakeholders',
      pkgs: [
        'package/contacts.v1',
        'package/member.v1',
        'package/memberships.v1',
        'package/notes.v1',
        'package/messages.v1'
      ]
    },
    {
      key: 'others',
      pkgs: [
        'package/dashboards.v1',
        'package/iam.v1',
        'package/ledgers.v1',
        'package/financials.v1'
      ]
    }
  ]

  packageFromName (name: string): Package | undefined {
    return this.pkgs.find(pkg => pkg.name === name)
  }

  isAppInstalled (name: string): boolean | undefined {
    const foundPackage = this.pkgs.find(pkg => pkg.name === name)
    const foundApp = this.apps.find(app => app.packageName === name)
    if (foundPackage !== undefined) {
      if (foundApp === undefined) {
        return false
      } else {
        return true
      }
    }
  }

  goToHomepage () {
    this.router.push({
      name: 'desktops'
    })
  }

  get installSuccess () {
    return this.desktopsStoreModule.isAppInstalled
  }

  async installApp (pkg: Package) {
    await this.desktopsStoreModule.asyncCreateApp(
      {
        package: pkg
      }
    )
    await this.desktopsStoreModule.asyncListApps()
    await this.desktopsStoreModule.asyncListPackages()
  }

  async deleteApp (appId: string) {
    await this.desktopsStoreModule.asyncDeleteApp({
      appId: appId
    })
    this.desktopsStoreModule.asyncListApps()
    this.desktopsStoreModule.asyncListPackages()
  }

  uninstall (name: string) {
    const foundApp = this.apps.find(app => app.packageName === name)
    if (foundApp !== undefined) {
      this.deleteApp(foundApp.id)
    }
  }

  selectedPackage: Package | null = null
  isShowingDetails = false

  showPackageDetails (pkg: Package | null) {
    this.selectedPackage = pkg
    this.isShowingDetails = true
  }

  closeOverlay () {
    this.isShowingDetails = false
    this.selectedPackage = null
  }

  isShowingInstalled = false

  goToInstalled () {
    this.isShowingInstalled = true
    this.isShowingDetails = false
  }

  goToDiscovery () {
    this.isShowingInstalled = false
    this.isShowingDetails = false
  }

  menuButtonStyle (selected: boolean) {
    return {
      'pr-3 pl-4 mb-2 rounded-full h-12 w-full flex items-center justify-between shadow': true,
      'bg-white': selected,
      'bg-white bg-opacity-25 backdrop-filter background-blur-2xl': !selected
    }
  }
}
